import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading, Subheading as SubheadingBase } from "components/misc/Headings.js";
import { SectionDescription } from "components/misc/Typography.js";

import defaultCardImage from "images/shield-icon.svg";


import SupportIconImage from "images/support-icon.svg";
import ShieldIconImage from "images/shield-icon.svg";
import CustomizeIconImage from "images/customize-icon.svg";
import FastIconImage from "images/fast-icon.svg";
import ReliableIconImage from "images/reliable-icon.svg";
import SimpleIconImage from "images/simple-icon.svg";

const Container = tw.div`relative`;

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-lg mx-auto py-20 md:py-24`}
`;
const Subheading = tw(SubheadingBase)`mb-4`;
const Heading = tw(SectionHeading)`w-full`;
const Description = tw(SectionDescription)`w-full text-center`;

const VerticalSpacer = tw.div`mt-10 w-full`

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 max-w-sm`}
`;

const Card = styled.div`
  ${tw`flex flex-col sm:flex-row items-center sm:items-start text-center sm:text-left h-full mx-4 px-2 py-8`}
  .imageContainer {
    ${tw`border text-center rounded-full p-5 flex-shrink-0`}
    img {
      ${tw`w-6 h-6`}
    }
  }

  .textContainer {
    ${tw`sm:ml-4 mt-4 sm:mt-2`}
  }

  .title {
    ${tw`mt-4 tracking-wide font-bold text-2xl leading-none`}
  }

  .description {
    ${tw`mt-1 sm:mt-4 font-medium text-secondary-300 leading-loose`}
  }
`;


export default ({ cards = null, heading = "Built for HR. Trusted by Teams.", subheading = "", description = "Everything an HR team needs to receive, investigate and resolve workplace concerns — with the safeguards that make people willing to speak up." }) => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component) or you can directly pass this using the cards prop:
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const defaultCards = [
    // Every card describes shipped functionality. Previous copy promised
    // automated case routing, a "disguise mode" decoy screen and real-time
    // messaging - none of which exist in the app.
    {
      imageSrc: ShieldIconImage,
      title: "Anonymous Reporting",
      description: "Employees can report anonymously or sign in to follow their case. Anonymous reporters get a one-time key to check progress and reply."
    },
    {
      imageSrc: SupportIconImage,
      title: "Two-Way Messaging",
      description: "Caseworkers and reporters talk within each case — including anonymous reporters, who never have to reveal who they are."
    },
    {
      imageSrc: CustomizeIconImage,
      title: "Case Management",
      description: "Move cases from open to resolved, reassign between caseworkers, and keep internal notes the reporter never sees."
    },
    {
      imageSrc: ReliableIconImage,
      title: "Role-Based Access",
      description: "Admins, caseworkers, leadership and employees each see only what their role requires."
    },
    {
      imageSrc: FastIconImage,
      title: "Disguise Mode",
      description: "One click, or Esc twice, swaps the report for an ordinary weather page. Do it again and carry on exactly where you left off."
    },
    {
      imageSrc: SimpleIconImage,
      title: "Audit Trail",
      description: "Every case view and change is recorded in an append-only log, so you can always show who accessed what, and when."
    }
  ];

  if (!cards) cards = defaultCards;

  return (
    <Container>
      <ThreeColumnContainer>
        {subheading && <Subheading>{subheading}</Subheading>}
        <Heading>{heading}</Heading>
        {description && <Description>{description}</Description>}
        <VerticalSpacer />
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="textContainer">
                <span className="title">{card.title || "Fully Secure"}</span>
                <p className="description">
                  {card.description || "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
    </Container>
  );
};
